
@switch (appearance) {
  @case ('text') {
    <code
      #container
      (click)="copy()">
      <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
    </code>
  }
  @case ('button') {
    <button matTooltip
      #tooltip="matTooltip"
      matTooltipPosition="right"
      mat-icon-button
      (click)="copy(); $event.stopImmediatePropagation()">
      <mat-icon>file_copy</mat-icon>
    </button>
    <code #container style="position: absolute; font-size: 0; z-index: -1000">
      <ng-container *ngTemplateOutlet="contentTpl"></ng-container>
    </code>
  }
}

<ng-template #contentTpl><ng-content></ng-content></ng-template>
